function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { asyncToGenerator as _asyncToGenerator } from "../_virtual/_rollupPluginBabelHelpers.js";
import 'prop-types';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import AnnotationLayer from "./annotation/AnnotationLayer.js";
import useIntersection from "../hooks/useIntersection.js";

var usePageRender = function usePageRender(canvasRef, pageProxy) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      rendering = _useState2[0],
      setRendering = _useState2[1];

  var previousScaleRef = useRef();
  var renderPage = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(scale) {
      var canvas, viewport, _map, _map2, width, height, renderContext;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              canvas = canvasRef.current;
              /**
               * Skipping canvas re-rendering if the page's scale remains the same
               * For e.g.:
               *    Let's say page 1 was rendered, then user scrolled to page 10,
               *    then back to page 1, if the scale hasn't changed through out the whole thing,
               *    no need to re-draw the page onto the canvas
               */

              if (!(scale === previousScaleRef.current)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              viewport = pageProxy.getViewport({
                scale: scale
              });
              _map = [viewport.width, viewport.height].map(Math.round), _map2 = _slicedToArray(_map, 2), width = _map2[0], height = _map2[1];
              canvas.height = height;
              canvas.width = width;
              renderContext = {
                canvasContext: canvas.getContext('2d'),
                viewport: viewport
              };
              previousScaleRef.current = scale;
              setRendering(true);
              _context.next = 12;
              return pageProxy.render(renderContext).promise;

            case 12:
              setRendering(false);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [canvasRef, pageProxy, previousScaleRef]);
  return {
    rendering: rendering,
    renderPage: renderPage
  };
};

var CanvasAndAnnotations = observer(function (_ref2) {
  var _pageStore$pdfStore$p;

  var pageStore = _ref2.pageStore;
  var canvasRef = useRef(null);
  var pageProxy = pageStore.pageProxy;
  var viewport = pageProxy.getViewport({
    scale: pageStore.pdfDocumentStore.scale
  });

  var _usePageRender = usePageRender(canvasRef, pageProxy),
      rendering = _usePageRender.rendering,
      renderPage = _usePageRender.renderPage;

  var _map3 = [viewport.width, viewport.height].map(Math.round),
      _map4 = _slicedToArray(_map3, 2),
      width = _map4[0],
      height = _map4[1];

  pageStore.setDimensions(width, height);
  var intersections = useIntersection(canvasRef, {
    root: (_pageStore$pdfStore$p = pageStore.pdfStore.pdfWrapperRef) === null || _pageStore$pdfStore$p === void 0 ? void 0 : _pageStore$pdfStore$p.current,
    rootMargin: '200%',
    threshold: 0
  });
  useEffect(function () {
    /**
     * Skipping canvas rendering if intersectability cannot be determined or is false
     * This handles 2 scenarios:
     *    1. When component first mounted and intersection is still being calculated
     *      (intersection object is null)
     *    2. When intersection.isIntersecting being false that means the component
     *      is not visible
     */
    if (!(intersections === null || intersections === void 0 ? void 0 : intersections.find(function (intersection) {
      return intersection.isIntersecting;
    }))) {
      return;
    }

    renderPage(pageStore.pdfDocumentStore.scale);
  }, [intersections, pageStore.pdfDocumentStore.scale, renderPage]);
  return jsx(React.Fragment, null, jsx("canvas", {
    ref: canvasRef,
    width: width,
    height: height
  }), !rendering && jsx(AnnotationLayer, {
    width: width,
    height: height,
    pageStore: pageStore,
    scale: pageStore.pdfDocumentStore.scale
  }));
});

var PdfPage = function PdfPage(_ref3) {
  var pageStore = _ref3.pageStore;
  useEffect(function () {
    pageStore.pdfDocumentStore.documentProxy.getPage(pageStore.pageNumber).then(pageStore.setPageProxy);
  }, [pageStore]);
  return !pageStore.pageProxy ? null : jsx("div", {
    className: "mx-auto position-relative"
  }, jsx(CanvasAndAnnotations, {
    pageStore: pageStore
  }));
};

var PdfPage$1 = observer(PdfPage);
export default PdfPage$1;